// Empty in dev (Vite proxies /api and /og to localhost:8787) and on a same-origin
// custom domain. On *.pages.dev we hit the Worker cross-origin (CORS allowed).
const API_BASE =
  typeof window !== 'undefined' && window.location.hostname.endsWith('.pages.dev')
    ? 'https://gay-certification.victor-053.workers.dev'
    : '';

async function postJson(path, body) {
  const res = await fetch(API_BASE + path, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error ?? `request failed: ${res.status}`);
  }
  return res.json();
}

async function getJson(path) {
  const res = await fetch(API_BASE + path);
  if (!res.ok) throw new Error(`request failed: ${res.status}`);
  return res.json();
}

export function certify({ name, referrerId }) {
  return postJson('/api/certify', { name, referrerId: referrerId ?? null });
}

export function getCert(id) {
  return getJson(`/api/cert/${id}`);
}

export async function getCounter() {
  try {
    const data = await getJson('/api/counter');
    return data.total;
  } catch {
    return null;
  }
}

export function placeOrder(payload) {
  return postJson('/api/order', payload);
}
